import { Component } from "../../base/Component";
import { ComponentFactory } from "../../../service/ComponentFactory";
import { PageContext } from "../../../service/PageContext";

export class GoogleIdentityBottom extends Component {
  constructor(element: HTMLElement, pageContext: PageContext) {
    super(element, pageContext);

    document.addEventListener("DOMContentLoaded", () => {
      this.handleDocumentReady();
    });

    document.addEventListener("Healio.GoogleSSO.Callback", () => {
      this.startSso();
    });
  }

  public static init(pageContext: PageContext): void {
    const element = document.createElement("div");
    new GoogleIdentityBottom(element, pageContext);
  }

  private getUrlParameter(name: string): string | null {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  }

  private handleDocumentReady(): void {
    const loginParam = this.getUrlParameter("login");
    if (loginParam === "1") {
      fetch("/loginregistration/modals/loadloginmodal?islocked=false")
        .then((response) => response.text())
        .then((data) => {
          document.body.insertAdjacentHTML("beforeend", data);
        });
    }
  }

  private startSso(): void {
    const params = new URLSearchParams();
    params.set("provider", "google");
    params.set("returnUrl", window.location.href);
    params.set("source", this.registrationSource());
    window.location.href = "/loginregistration/healiosso/start?" + params.toString();
  }

  private registrationSource(): string {
    const returnUrl = window.location.href.toLowerCase();
    if (returnUrl.indexOf("/cme/") > 0 || returnUrl.endsWith("/cme")) {
      return "cme";
    }
    if (returnUrl.indexOf("/clinical-guidance/") > 0 || returnUrl.endsWith("/clinical-guidance")) {
      return "clinicalguidance";
    }
    if (returnUrl.indexOf("/community/") > 0 || returnUrl.endsWith("/community")) {
      return "community";
    }
    return "news";
  }
}

ComponentFactory.registerComponent(
  "GoogleIdentityBottom",
  GoogleIdentityBottom
);
